import Vue from 'vue'
import axios from 'axios'
import API from '@s/API'
import Utils from '@s/utils'


const state = {
    plugins: [],
    configurations: [],
    categories: [],
    providers: [],
    currentPlugin: {
        descriptor: {},
        configuration: {},
        configurationId: null
    },
    currentStep: 0,
    currentStepData: {}

}

const getters = {
    plugins: state => {
        return state.plugins
    },
    configurations: state => {
        return state.configurations
    },
    categories: state => {
        return state.categories
    },
    providers: state => {
        return state.providers
    },
    current: state => {
        return state.currentPlugin
    },
    currentStep: state => {
        return state.currentStep
    },
    currentStepData: state => {
        return state.currentStepData
    }
}

const mutations = {
    plugins(state, plugins) {
        state.plugins = plugins
    },
    configurations(state, configurations) {
        state.configurations = configurations
    },
    categories(state, categories) {
        state.categories = categories
    },
    providers(state, providers) {
        state.providers = providers
    },
    setCurrentPlugin(state, plugin) {
        console.log('plugin', plugin)
        //this.currentPlugin = plugin
        Vue.set(state, 'currentPlugin', plugin)
        Vue.set(state.currentPlugin, 'configuration', {})

        plugin.configDescriptor.tokens.forEach(item => {
            Vue.set(state.currentPlugin.configuration, item.key, Utils.initValueFromType(item.type))
        })

        plugin.configDescriptor.form.steps.forEach(step => {
            step.fields.forEach(item => {
                if (item.key) {
                    Vue.set(state.currentPlugin.configuration, item.key, {})
                }
            })
        })

        console.log(state.currentPlugin.configuration)


    },
    setConfiguration(state, configuration) {
        Vue.set(state.currentPlugin, 'configuration', configuration)

        state.currentPlugin.configDescriptor.tokens.forEach(item => {
            if (!state.currentPlugin.configuration[item.key]) {
                Vue.set(state.currentPlugin.configuration, item.key, Utils.initValueFromType(item.type))
            }
        })

        state.currentPlugin.configDescriptor.form.steps.forEach(step => {
            step.fields.forEach(item => {

                if (item.key) {
                    if (!state.currentPlugin.configuration[item.key]) {
                        Vue.set(state.currentPlugin.configuration, item.key, {})
                    }
                }
            })
        })
    },
    setCurrentStep(state, step) {
        Vue.set(state, 'currentStep', step)

    },
    setCurrentStepData(state, data) {
        Vue.set(state, 'currentStepData', data)
    },
    setConfigurationId(state, configurationId) {
        Vue.set(state.currentPlugin, 'configurationId', configurationId)
    },

    setFinalStepMessage(state,message){
        console.log('setFinalStepMessage',state.currentPlugin.configDescriptor.form.steps[state.currentPlugin.configDescriptor.form.steps.length - 1].fields[0].label.replace('{finalizeMessage}',message))
        Vue.set(state.currentPlugin.configDescriptor.form.steps[state.currentPlugin.configDescriptor.form.steps.length - 1].fields[0],'label',state.currentPlugin.configDescriptor.form.steps[state.currentPlugin.configDescriptor.form.steps.length - 1].fields[0].label.replace('{finalizeMessage}',message))
    },

    injectFinalStep(state) {
        const finalStep = {
            label: "Confirmation",
            before: false,
            fields: [{
                token: null,
                message: true,
                label: "<b>Votre connecteur est prêt à être activé</b><br><br><br>{finalizeMessage}",
            }]
        }

        //state.currentPlugin.configDescriptor.form.steps.unshift(finalStep)


        state.currentPlugin.configDescriptor.form.steps.push(finalStep)
    }
}

const actions = {

    fetchPlugins(context) {

        let promises = []

        let promiseList = axios.get(API.endpoints.plugins.library)
            .then(response => {
                context.commit('plugins', response.data.data)
            })

        promises.push(promiseList)

        let promiseCategories = axios.get(API.endpoints.plugins.categories)
            .then(response => {
                context.commit('categories', response.data.data)
            })

        promises.push(promiseCategories)

        let promiseProviders = axios.get(API.endpoints.plugins.providers)
            .then(response => {
                context.commit('providers', response.data.data)
            })

        promises.push(promiseProviders)

        return promises
    },

    fetchConfigurations(context) {

        let promises = []

        let promiseList = axios.get(API.endpoints.plugins.configurations)
            .then(response => {
                context.commit('configurations', response.data.data)
            })

        promises.push(promiseList)

        let promiseProviders = axios.get(API.endpoints.plugins.providers)
            .then(response => {
                context.commit('providers', response.data.data)
            })

        promises.push(promiseProviders)

        return promises
    },

    fetchPluginDescription(context, pluginId) {
        return axios.get(API.route(API.endpoints.plugins.show, {id: pluginId}))
            .then(response => {
                context.commit('setCurrentPlugin', response.data)
                context.commit('injectFinalStep')
            })
    },

    fetchPluginConfiguration(context, configurationId) {
        return axios.get(API.route(API.endpoints.plugins.edit, {id: configurationId}))
            .then(responseConfiguration => {
                return axios.get(API.route(API.endpoints.plugins.show, {id: responseConfiguration.data.plugin.pluginId}))
                    .then(responsePlugin => {
                        context.commit('setCurrentPlugin', responsePlugin.data)
                        context.commit('setConfiguration', responseConfiguration.data.configuration)
                        context.commit('setConfigurationId', configurationId)
                        context.commit('injectFinalStep')
                    })

            })
    },

    createPlugin(context, plugin) {
        console.log(plugin);
        return axios.post(API.route(API.endpoints.plugins.show, {id: plugin.pluginId}), plugin.configuration)
    },

    beforePluginStep(context, configurationId) {
        let promise = axios.get(API.route(API.endpoints.plugins.step, {
            id: configurationId,
            step: context.getters.currentStep
        }))
        promise.then(response => {
            context.commit('setCurrentStepData', response.data)
        })
        return promise
    },

    beforeFinalize(context, configurationId) {
        let promise = axios.get(API.route(API.endpoints.plugins.finalize, {
            id: configurationId
        }))
        /*promise.then(response => {
            context.commit('setCurrentStepData', response.data)
        })*/
        return promise
    },

    checkPluginStep(context, plugin) {
        return axios.put(API.route(API.endpoints.plugins.step, {
            id: plugin.configurationId,
            step: context.getters.currentStep
        }), plugin.configuration)
    },

    activateConfiguration(context, configuration) {
        return axios.put(API.route(API.endpoints.plugins.activation, {id: configuration.id}), {activate: configuration.activation})
    },

    deleteConfiguration(context, configuration) {
        return axios.delete(API.route(API.endpoints.plugins.edit, {id: configuration.id}))
    },

    fetchCategories(context, payload) {
        return axios.get(API.endpoints.plugins.categories)
            .then(response => {
                context.commit('categories', response.data.data)
            })
    },
    finalizeConfiguration(context, configuration){
        return axios.put(API.route(API.endpoints.plugins.finalize, {id: configuration.id}))
    },
    synchronizeConfiguration(context, configuration){
        return axios.put(API.route(API.endpoints.plugins.synchronize, {id: configuration.id}))
    },

    suggest(context,payload){
        return axios.post(API.route(API.endpoints.plugins.suggest),payload)
    }
}

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;


// WEBPACK FOOTER //
// ./src/stores/modules/plugins/store.js